

import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useTenant } from "../../context/TenantContext";
import config from '../../config/config';
import "../../styles/Orchestrator.css";

const FolderSelection = ({ onChange, folder, tenant = null, folders = null, isGlobal = true }) => {
  const { selectedTenant } = useTenant();
  const [localFolders, setLocalFolders] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const activeTenant = isGlobal ? selectedTenant : tenant;

  const latestFolderRef = useRef(folder);
  useEffect(() => {
    latestFolderRef.current = folder;
  }, [folder]);

  const renderPlaceholder = () => {
    if (!activeTenant) return "Please select a tenant first";
    if (isLoading) return "Loading folders...";
    if (!localFolders.length) return "No folders available";
    return "Select folder";
  };

  const fetchFolders = async () => {
    if (!activeTenant) return;

    setIsLoading(true);
    try {
      const token = localStorage.getItem("userToken");
      if (!token) {
        setError("❌ Missing token");
        setIsLoading(false);
        return;
      }

      const res = await axios.get(
        `${config.API_BASE_URL}/api/orchestrator/folders/tenant/${activeTenant.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            'selected-tenant': JSON.stringify(activeTenant),
            'X-UIPATH-OrganizationUnitId': activeTenant.orch_tenant_id.toString()
          },
        }
      );

      if (res.data && Array.isArray(res.data.folders)) {
        const sortedFolders = res.data.folders
          .filter(folder => folder && (folder.name || folder.DisplayName))
          .sort((a, b) => {
            const nameA = a.name || a.DisplayName || '';
            const nameB = b.name || b.DisplayName || '';
            return nameA.localeCompare(nameB);
          });
        setLocalFolders(sortedFolders);
        setError("");
      } else {
        setLocalFolders([]);
        setError("No folders available");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setLocalFolders([]);
      setError("Failed to fetch folders");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!folders && activeTenant) {
      fetchFolders();
    } else if (folders) {
      const sorted = [...folders].sort((a, b) => {
        const nameA = a.name || a.DisplayName || '';
        const nameB = b.name || b.DisplayName || '';
        return nameA.localeCompare(nameB);
      });
      setLocalFolders(sorted);
      setIsLoading(false);

      if (sorted.length > 0 && (folder === "" || folder === null || folder === undefined)) {
        onChange(sorted[0].Id);
      }
    }
  }, [activeTenant, folders]);

  return (
    <div className="form-group">
      <label>Select Folder *</label>
      <select
        value={folder || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={!activeTenant || isLoading}
      >
        <option value="">{renderPlaceholder()}</option>
        {localFolders.map((f) => (
          <option key={f.id || f.Id} value={f.id || f.Id}>
            {f.name || f.DisplayName}
          </option>
        ))}
      </select>
      {error && <span className="inline-tooltip">{error}</span>}
    </div>
  );
};

export default FolderSelection;
